import { when } from "util/support";
import { ResponseCode } from "consts/api";
import { downloadFile } from "features/general/api";
import useGeneralActions from "features/general/useActions";
import { NotificationSeverity } from "features/general/types";

export const useDownloadFile = (downloadFileApi = downloadFile) => {
    const { showNotication } = useGeneralActions();

    return async (params: Parameters<typeof downloadFileApi>[0]) => {
        const response = await downloadFileApi(params);

        when(!response.ok, () => showNotication({
            severity: NotificationSeverity.Error,
            message: {
                [ResponseCode.NotFound]: 'File not found.',
            }[response.status] ?? 'An error occurred while downloading the file.'
        }));

        return response;
    };
};

export default useDownloadFile;
